import { useEffect } from 'react';
import Modal from 'react-modal';
import { cn } from '../../utils/classNames';

const baseContentStyle = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  transform: 'translate(-50%, -50%)',
  overflow: 'hidden',
};

const overlayStyle = { zIndex: 3 };

// react-modal defaults its panel to white; the dialogs are Ivory like every other popup.
const surfaceStyle = { backgroundColor: 'var(--color-surface)' };

const modeContentStyles = {
  full: { height: '80vh', width: '80vw', border: '2px solid var(--color-border)' },
  half: { maxHeight: '85vh', width: '768px', borderRadius: '18px' },
  'single-column': { maxHeight: '85vh', width: '400px', height: '100%', borderRadius: '18px' },
  'semi-half': { minHeight: '321px', maxHeight: '85vh', width: '768px', borderRadius: '18px' },
  fit: { width: '768px', borderRadius: '18px' },
  'small-half': { minHeight: '280px', maxHeight: '75vh', width: '600px', borderRadius: '18px' },
};

const resolveContentStyle = ({ mode, customStyle, additionalStyle }) => {
  if (mode === 'custom') return { ...surfaceStyle, ...customStyle };
  const modeStyle = modeContentStyles[mode] ?? modeContentStyles.full;
  return { ...surfaceStyle, ...baseContentStyle, ...modeStyle, ...additionalStyle };
};

const Dialog = ({
  onToggleDialog,
  isModalOpen,
  children,
  mode = 'full',
  style,
  additionalStyle,
  dialogContentClass,
  onAfterModalOpen,
}) => {
  useEffect(() => {
    onToggleDialog(isModalOpen);
     
  }, [isModalOpen]);

  const closeModal = () => onToggleDialog(false);

  const contentStyle = resolveContentStyle({
    mode,
    customStyle: style,
    additionalStyle,
  });

  return (
    <Modal
      id="modal-dialog"
      shouldCloseOnOverlayClick
      shouldCloseOnEsc={false}
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      style={{ content: contentStyle, overlay: overlayStyle }}
      contentLabel="Dialog"
      ariaHideApp={false}
      onAfterOpen={onAfterModalOpen}
    >
      <div className={cn(dialogContentClass)}>
        {children}
      </div>
    </Modal>
  );
};

export default Dialog;
